import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnowAnimationService } from './service/snow-animation.service';

@Component({
  selector: 'app-items-falling-anim',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './items-falling-anim.component.html',
  styleUrls: ['./items-falling-anim.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemsFallingAnimComponent {
  protected readonly showSnowAnimation$ =
    this.snowAnimationService.flagsLoaded$;

  protected readonly snowSymbols = ['❄️'];

  protected readonly items = Array.from(
    { length: 500 },
    () => this.snowSymbols[Math.floor(Math.random() * this.snowSymbols.length)]
  );

  constructor(private readonly snowAnimationService: SnowAnimationService) {}
}
